__webpack_require__.p = "/frontend/kasa-loyalty/";